import { render, staticRenderFns } from "./AllImageGallery.vue?vue&type=template&id=078aa969"
import script from "./AllImageGallery.vue?vue&type=script&lang=ts"
export * from "./AllImageGallery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports